import Timer from "@/components/timer/index.vue";

import { mapGetters } from "vuex";

export default {
    data() {
        return {
            // trans: this.$t('andDateActions')
            trans: {
                day: "Годин",
                hours: "Годин",
                minutes: "Хвилин",
                seconds: "Секунд",
                expired: "Акція закінчилась.",
                running: "",
                upcoming: "",
                status: {
                    expired: "",
                    running: "",
                    upcoming: "",
                },
            },
        };
    },
    name: "banner",
    components: { Timer },
    props: ["title", "description", "path", "startTime", "endTime"],
    computed: {
        ...mapGetters({
            getList: `promotions/getList`,
            getCurrentList: "promotions/getCurrentList",
            productLoading: "promotions/productLoading",
        }),
    },
};
